export const dashboardStatsData = {
    // Stats para CardStats 
    totalCentros: {
        title: "Total Centros",
        subtitle: "Activos en la red",
        metrics: {
            Semana: {
                amount: "187",
                percentageValue: 12.5,
                percentageText: "vs semana anterior",
            },
            Mes: {
                amount: "185",
                percentageValue: 8.2,
                percentageText: "vs mes anterior",
            },
            Año: {
                amount: "180",
                percentageValue: 15.3,
                percentageText: "vs año anterior",
            },
        },
    },
    cantidadGenerada: {
        title: "Cantidad generada",
        subtitle: "Total procesado",
        metrics: {
            Semana: {
                amount: "132.006 tn",
                percentageValue: 48.35,
                percentageText: "vs semana anterior",
            },
            Mes: {
                amount: "128.450 tn", 
                percentageValue: 35.2,
                percentageText: "vs mes anterior",
            },
            Año: {
                amount: "120.890 tn",
                percentageValue: 52.1,
                percentageText: "vs año anterior",
            },
        },
    },
    eficienciaGlobal: {
        title: "Eficiencia global",
        subtitle: "Valorización promedio",
        metrics: {
            Semana: {
                amount: "72,21%",
                percentageValue: 5.8,
                percentageText: "mejora",
            },
            Mes: {
                amount: "69,15%",
                percentageValue: 3.2,
                percentageText: "mejora", 
            },
            Año: {
                amount: "71,80%",
                percentageValue: 8.5,
                percentageText: "mejora",
            },
        },
    },
};

// Top países 
export const topPaisesData = [
    {
        id: 1,
        pais: "España",
        cantidadGenerada: "273.041,08",
        rp: "132,83",
        rnp: "272.908,25",
        valorizacion: "54,85%"
    },
    {
        id: 2,
        pais: "Eslovaquia",
        cantidadGenerada: "97,50",
        rp: "0,00",
        rnp: "97,50",
        valorizacion: "100,00%"
    },
    {
        id: 3,
        pais: "Reino Unido",
        cantidadGenerada: "2277,84",
        rp: "2,73",
        rnp: "2275,11",
        valorizacion: "99,46%"
    },
    {
        id: 4,
        pais: "Italia",
        cantidadGenerada: "32.143,53",
        rp: "31,98",
        rnp: "32.111,56",
        valorizacion: "93,60%"
    },
    {
        id: 5,
        pais: "Bélgica",
        cantidadGenerada: "202,06",
        rp: "0,79",
        rnp: "201,27",
        valorizacion: "93,06%"
    },
    {
        id: 6,
        pais: "Polonia",
        cantidadGenerada: "1204,39",
        rp: "6,18",
        rnp: "1198,21",
        valorizacion: "88,44%"
    },
];

export const columnasPaises = [
    { key: "pais", label: "País", sortable: true },
    { key: "cantidadGenerada", label: "Cantidades generadas tn", sortable: true },
    { key: "rp", label: "RP", sortable: true },
    { key: "rnp", label: "RNP", sortable: true },
    { key: "valorizacion", label: "Valorización", sortable: true },
];

// Datos ProgressCircle
export const indicadoresData = [
    {
        percentage: 72,
        label: "Valorización",
        value: "72,21%"
    },
    {
        percentage: 48,
        label: "Eficiencia",
        value: "48,5%"
    },
    {
        percentage: 36,
        label: "Cumplimiento",
        value: "36,2%"
    },
    {
        percentage: 92,
        label: "Calidad",
        value: "92,3%"
    },
    {
        percentage: 61,
        label: "Seguridad",
        value: "61,1%"
    },
    {
        percentage: 82,
        label: "Sostenibilidad",
        value: "82,7%"
    },
     {
        percentage: 39,
        label: "Otro",
        value: "39,7%"
    }
];

export const centrosMapData = [
  {
    id: 1,
    nombre: "Centro Madrid Norte",
    direccion: "Avenida Río Guadalquivir 15, Madrid, España",
    latitud: 40.4168,
    longitud: -3.7038,
    fechaInicio: "05/03/2024",
    fechaFin: "25/05/2024",
    intermediario: "IAC",
    cantidadGenerada: "244825 kg",
    coste: "15270.49 €",
    valorizacion: 77,
    cumplimiento: "Correcto"
  },
  {
    id: 2,
    nombre: "Centro Porto",
    direccion: "Rua de Santa Catarina 112, Porto, Portugal",
    latitud: 41.1496,
    longitud: -8.6109,
    fechaInicio: "10/02/2024",
    fechaFin: "15/06/2024",
    intermediario: "PORTO ECO",
    cantidadGenerada: "189450 kg",
    coste: "12800.30 €",
    valorizacion: 83,
    cumplimiento: "Correcto"
  },
  {
    id: 3,
    nombre: "Centro Marsella",
    direccion: "Rue de Rome 58, Marsella, Francia",
    latitud: 43.2965,
    longitud: 5.3698,
    fechaInicio: "15/02/2024",
    fechaFin: "20/06/2024",
    intermediario: "ECO-FR",
    cantidadGenerada: "189230 kg",
    coste: "12450.30 €",
    valorizacion: 85,
    cumplimiento: "Correcto"
  },
  {
    id: 4,
    nombre: "Centro Lyon",
    direccion: "Rue de la République 67, Lyon, Francia",
    latitud: 45.7640,
    longitud: 4.8357,
    fechaInicio: "20/03/2024",
    fechaFin: "25/07/2024",
    intermediario: "LYON GREEN",
    cantidadGenerada: "145670 kg",
    coste: "9850.75 €",
    valorizacion: 81,
    cumplimiento: "Correcto"
  },
  {
    id: 5,
    nombre: "Centro Roma",
    direccion: "Via del Corso 80, Roma, Italia",
    latitud: 41.9028,
    longitud: 12.4964,
    fechaInicio: "15/01/2024",
    fechaFin: "30/05/2024",
    intermediario: "ROMA RECYCLE",
    cantidadGenerada: "98750 kg",
    coste: "6200.50 €",
    valorizacion: 78,
    cumplimiento: "Correcto"
  },
  {
    id: 6,
    nombre: "Centro Milán",
    direccion: "Corso Buenos Aires 20, Milán, Italia",
    latitud: 45.4642,
    longitud: 9.1900,
    fechaInicio: "20/01/2024",
    fechaFin: "15/07/2024",
    intermediario: "MILANO GREEN",
    cantidadGenerada: "156890 kg",
    coste: "9850.75 €",
    valorizacion: 82,
    cumplimiento: "Correcto"
  },
  {
    id: 7,
    nombre: "Centro Florencia",
    direccion: "Via dei Calzaiuoli 30, Florencia, Italia",
    latitud: 43.7696,
    longitud: 11.2558,
    fechaInicio: "25/02/2024",
    fechaFin: "20/08/2024",
    intermediario: "FIRENZE ECO",
    cantidadGenerada: "134500 kg",
    coste: "8750.40 €",
    valorizacion: 79,
    cumplimiento: "Correcto"
  },
  {
    id: 8,
    nombre: "Centro Oslo",
    direccion: "Karl Johans gate 5, Oslo, Noruega",
    latitud: 59.9139,
    longitud: 10.7522,
    fechaInicio: "15/03/2024",
    fechaFin: "10/09/2024",
    intermediario: "NORWAY GREEN",
    cantidadGenerada: "87650 kg",
    coste: "5640.20 €",
    valorizacion: 75,
    cumplimiento: "PENDIENTE"
  },
  {
    id: 9,
    nombre: "Centro Madrid Sur",
    direccion: "Calle Alcalá 200, Madrid, España",
    latitud: 40.3999,
    longitud: -3.6819,
    fechaInicio: "10/02/2024",
    fechaFin: "15/06/2024",
    intermediario: "MADRID ECO",
    cantidadGenerada: "189450 kg",
    coste: "12800.30 €",
    valorizacion: 83,
    cumplimiento: "Correcto"
  },
  {
    id: 10,
    nombre: "Centro Barcelona",
    direccion: "Carrer de la Marina 25, Barcelona, España",
    latitud: 41.3851,
    longitud: 2.1734,
    fechaInicio: "15/02/2024",
    fechaFin: "20/06/2024",
    intermediario: "ECO-CAT",
    cantidadGenerada: "189230 kg",
    coste: "12450.30 €",
    valorizacion: 85,
    cumplimiento: "Correcto"
  },
  {
    id: 11,
    nombre: "Centro Lisboa",
    direccion: "Avenida da Liberdade 100, Lisboa, Portugal",
    latitud: 38.7223,
    longitud: -9.1393,
    fechaInicio: "12/04/2024",
    fechaFin: "15/10/2024",
    intermediario: "LISBOA GREEN",
    cantidadGenerada: "98450 kg",
    coste: "6780.30 €",
    valorizacion: 76,
    cumplimiento: "Correcto"
  },
  {
    id: 12,
    nombre: "Centro Bergen",
    direccion: "Bryggen 9, Bergen, Noruega",
    latitud: 60.3913,
    longitud: 5.3221,
    fechaInicio: "20/03/2024",
    fechaFin: "05/09/2024",
    intermediario: "BERGEN ECO",
    cantidadGenerada: "76540 kg",
    coste: "4920.15 €",
    valorizacion: 73,
    cumplimiento: "Correcto"
  }
];


// gráfico de barras 
export const barChartData = {
    chartData: {
        Semana: [
            { name: "Lun", uv: 1000, pv: 1800, amt: 1600 },
            { name: "Mar", uv: 2500, pv: 1200, amt: 1000 },
            { name: "Mié", uv: 3000, pv: 1500, amt: 1200 },
            { name: "Jue", uv: 1200, pv: 1900, amt: 1700 },
            { name: "Vie", uv: 2800, pv: 2400, amt: 2000 },
        ],
        Mes: [
            { name: "Sem 1", uv: 8000, pv: 7000, amt: 6500 },
            { name: "Sem 2", uv: 9500, pv: 8200, amt: 7800 },
            { name: "Sem 3", uv: 7800, pv: 6900, amt: 6200 },
            { name: "Sem 4", uv: 10200, pv: 9100, amt: 8600 },
        ],
        Año: [
            { name: "Q1", uv: 32000, pv: 28000, amt: 25000 },
            { name: "Q2", uv: 38000, pv: 32000, amt: 29000 },
            { name: "Q3", uv: 35000, pv: 30000, amt: 27000 },
            { name: "Q4", uv: 42000, pv: 36000, amt: 33000 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$18,200",
            percentageValue: 8.3,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$34,100",
            percentageValue: 12.7,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$147,000",
            percentageValue: -2.1,
            percentageText: "vs año anterior"
        }
    }
};

// gráfico de líneas 
export const lineChartData = {
    chartData: {
        Semana: [
            { name: "Lun", uv: 1200, pv: 2800, amt: 2600 },
            { name: "Mar", uv: 2800, pv: 1400, amt: 2200 },
            { name: "Mié", uv: 1600, pv: 2200, amt: 2900 },
            { name: "Jue", uv: 3100, pv: 3700, amt: 5300 },
            { name: "Vie", uv: 3900, pv: 3100, amt: 3100 },
            { name: "Sáb", uv: 3400, pv: 3000, amt: 1700 },
        ],
        Mes: [
            { name: "Sem 1", uv: 15000, pv: 12000, amt: 11000 },
            { name: "Sem 2", uv: 18000, pv: 14000, amt: 13000 },
            { name: "Sem 3", uv: 16000, pv: 13500, amt: 12500 },
            { name: "Sem 4", uv: 20000, pv: 16000, amt: 15000 },
        ],
        Año: [
            { name: "Ene", uv: 40000, pv: 24000, amt: 24000 },
            { name: "Feb", uv: 30000, pv: 13980, amt: 22100 },
            { name: "Mar", uv: 20000, pv: 98000, amt: 22900 },
            { name: "Abr", uv: 27800, pv: 39080, amt: 20000 },
            { name: "May", uv: 18900, pv: 48000, amt: 21810 },
            { name: "Jun", uv: 23900, pv: 38000, amt: 25000 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$42,100",
            percentageValue: -3.2,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$67,400",
            percentageValue: 5.8,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$325,000",
            percentageValue: 15.2,
            percentageText: "vs año anterior"
        }
    }
};

// area chart 
export const areaChartData = {
    chartData: {
        Semana: [
            { name: "Lun", uv: 4000, pv: 2400, amt: 2400 },
            { name: "Mar", uv: 3000, pv: 1398, amt: 2210 },
            { name: "Mié", uv: 2000, pv: 9800, amt: 2290 },
            { name: "Jue", uv: 2780, pv: 3908, amt: 2000 },
            { name: "Vie", uv: 1890, pv: 4800, amt: 2181 },
            { name: "Sáb", uv: 2390, pv: 3800, amt: 2500 },
        ],
        Mes: [
            { name: "Sem 1", uv: 15000, pv: 12000, amt: 11000 },
            { name: "Sem 2", uv: 18000, pv: 14000, amt: 13000 },
            { name: "Sem 3", uv: 16000, pv: 13500, amt: 12500 },
            { name: "Sem 4", uv: 20000, pv: 16000, amt: 15000 },
        ],
        Año: [
            { name: "Ene", uv: 40000, pv: 24000, amt: 24000 },
            { name: "Feb", uv: 30000, pv: 13980, amt: 22100 },
            { name: "Mar", uv: 20000, pv: 98000, amt: 22900 },
            { name: "Abr", uv: 27800, pv: 39080, amt: 20000 },
            { name: "May", uv: 18900, pv: 48000, amt: 21810 },
            { name: "Jun", uv: 23900, pv: 38000, amt: 25000 },
        ],
    },
    metrics: {
        Semana: {
            amount: "$24,500",
            percentageValue: 12.5,
            percentageText: "vs semana anterior"
        },
        Mes: {
            amount: "$56,000",
            percentageValue: 8.7,
            percentageText: "vs mes anterior"
        },
        Año: {
            amount: "$286,880",
            percentageValue: -2.3,
            percentageText: "vs año anterior"
        }
    }
};
